import '../../types/index.mjs';
export { parseLocaleToStoreLanguage } from './store.mjs';
import { Language } from '../../types/constants.mjs';
"use strict";
const isLanguage = language => {
  return !!language && Object.values(Language).includes(language);
};
export { isLanguage };
//# sourceMappingURL=index.mjs.map
